import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentAddFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 9a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v9l2-2h7ZM5.5 2.5v2h-2v1h2v2h1v-2h2v-1h-2v-2h-1Z"
    />
  </svg>
);
export default IconCommentAddFilledSizeXs;
